import moment from 'moment';

export const isSameMaster = (currentMaster, nextMaster) => {
  if (currentMaster === nextMaster) {
    return true;
  }
  if (currentMaster === 'all' || nextMaster === 'all' || !currentMaster || !nextMaster) {
    return false;
  }
  if (currentMaster.id && nextMaster.id) {
    return currentMaster.id === nextMaster.id;
  }
  return (
    currentMaster.surname === nextMaster.surname &&
    currentMaster.name === nextMaster.name
  );
};

export const getFormattedPeriod = (periodStart, periodEnd) => ({
  periodToStart:
    periodStart !== null
      ? moment(periodStart).locale('en').format('YYYY-MM-DD')
      : moment().subtract(1, 'week').locale('en').format('YYYY-MM-DD'),
  periodToEnd:
    periodEnd !== null
      ? moment(periodEnd).locale('en').format('YYYY-MM-DD')
      : moment().locale('en').format('YYYY-MM-DD')
});
